// M21: 概率 - Probability Problems Data
// 系統化數據結構，準備 Supabase 後端遷移
// 50個練習題目 (每個主題10題)

// ========== 1. 基本概率 (Basic Probability) ==========
export const M21_01_PROBLEMS = [
  {
    id: 'M21_01_P001',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'basic',
    points: 3,
    timeLimit: 300, // 5 minutes
    question: {
      text: '一個袋子裡有5個紅球和3個藍球。隨機抽取一個球，求抽到紅球的概率。',
      mathExpression: '求 P(紅球) = ?'
    },
    solution: {
      steps: [
        '總球數 = 5 + 3 = 8個',
        '紅球數 = 5個',
        'P(紅球) = 紅球數 ÷ 總球數',
        'P(紅球) = 5/8'
      ],
      finalAnswer: '5/8',
      explanation: '基本概率的計算公式：P(事件) = 有利結果數 ÷ 總可能結果數'
    },
    hint: '先計算總球數，再用紅球數除以總球數',
    tags: ['基本概率', '分數計算', 'HKDSE']
  },
  {
    id: 'M21_01_P002',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'basic',
    points: 3,
    timeLimit: 300,
    question: {
      text: '投擲一個公平的六面骰子，求得到偶數的概率。',
      mathExpression: '求 P(偶數) = ?'
    },
    solution: {
      steps: [
        '六面骰子的可能結果：{1, 2, 3, 4, 5, 6}',
        '偶數結果：{2, 4, 6}',
        '偶數個數 = 3個',
        'P(偶數) = 3/6 = 1/2'
      ],
      finalAnswer: '1/2',
      explanation: '偶數有2, 4, 6三個，總共6個可能結果'
    },
    hint: '找出所有偶數，然後計算它們在總結果中的比例',
    tags: ['基本概率', '骰子', '偶數']
  },
  {
    id: 'M21_01_P003',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'basic',
    points: 4,
    timeLimit: 360,
    question: {
      text: '一副標準撲克牌（52張）中，隨機抽取一張牌，求抽到紅桃的概率。',
      mathExpression: '求 P(紅桃) = ?'
    },
    solution: {
      steps: [
        '標準撲克牌總數 = 52張',
        '紅桃牌數 = 13張（A, 2, 3, ..., K）',
        'P(紅桃) = 13/52',
        'P(紅桃) = 1/4'
      ],
      finalAnswer: '1/4',
      explanation: '每種花色（紅桃、黑桃、方塊、梅花）各有13張牌'
    },
    hint: '標準撲克牌有4種花色，每種花色有多少張？',
    tags: ['基本概率', '撲克牌', '化簡分數']
  },
  {
    id: 'M21_01_P004',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 4,
    timeLimit: 420,
    question: {
      text: '一個班級有30名學生，其中12名男生，18名女生。隨機選擇一名學生做班長，求選到女生的概率。',
      mathExpression: '求 P(女生) = ?'
    },
    solution: {
      steps: [
        '總學生數 = 30名',
        '女生數 = 18名',
        'P(女生) = 18/30',
        'P(女生) = 3/5'
      ],
      finalAnswer: '3/5',
      explanation: '化簡分數：18/30 = (18÷6)/(30÷6) = 3/5'
    },
    hint: '用女生人數除以總人數，記得化簡分數',
    tags: ['基本概率', '實際應用', '化簡分數']
  },
  {
    id: 'M21_01_P005',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 4,
    timeLimit: 420,
    question: {
      text: '一個盒子裡有26個字母牌，隨機抽取一張，求抽到母音字母（A, E, I, O, U）的概率。',
      mathExpression: '求 P(母音) = ?'
    },
    solution: {
      steps: [
        '總字母數 = 26個',
        '母音字母：A, E, I, O, U',
        '母音字母數 = 5個',
        'P(母音) = 5/26'
      ],
      finalAnswer: '5/26',
      explanation: '英文有5個母音字母：A, E, I, O, U'
    },
    hint: '英文中有幾個母音字母？',
    tags: ['基本概率', '字母', '不可化簡分數']
  },
  {
    id: 'M21_01_P006',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在數字1到100中隨機選擇一個數字，求選到質數的概率。（1到100中有25個質數）',
      mathExpression: '求 P(質數) = ?'
    },
    solution: {
      steps: [
        '總數字範圍：1到100',
        '總數字個數 = 100個',
        '質數個數 = 25個（已給出）',
        'P(質數) = 25/100 = 1/4'
      ],
      finalAnswer: '1/4',
      explanation: '1到100中有25個質數，所以概率是25/100 = 1/4'
    },
    hint: '已知質數個數，直接計算概率並化簡',
    tags: ['基本概率', '質數', '大數字範圍']
  },
  {
    id: 'M21_01_P007',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'basic',
    points: 3,
    timeLimit: 300,
    question: {
      text: '擲兩枚硬幣，求至少出現一個正面的概率。',
      mathExpression: '求 P(至少一個正面) = ?'
    },
    solution: {
      steps: [
        '可能結果：{HH, HT, TH, TT}',
        '總結果數 = 4個',
        '至少一個正面：{HH, HT, TH}',
        '有利結果數 = 3個',
        'P(至少一個正面) = 3/4'
      ],
      finalAnswer: '3/4',
      explanation: '可以用對立事件：P(至少一個正面) = 1 - P(全是反面) = 1 - 1/4 = 3/4'
    },
    hint: '列出所有可能結果，或使用對立事件計算',
    tags: ['基本概率', '硬幣', '至少問題']
  },
  {
    id: 'M21_01_P008',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 4,
    timeLimit: 420,
    question: {
      text: '一個轉盤分為8等分，其中3個紅色，2個藍色，3個綠色。轉動轉盤，求指針指向藍色的概率。',
      mathExpression: '求 P(藍色) = ?'
    },
    solution: {
      steps: [
        '總等分數 = 8個',
        '藍色等分數 = 2個',
        'P(藍色) = 2/8',
        'P(藍色) = 1/4'
      ],
      finalAnswer: '1/4',
      explanation: '轉盤被分為8等分，藍色佔其中2個'
    },
    hint: '用藍色區域數除以總區域數',
    tags: ['基本概率', '轉盤', '等分']
  },
  {
    id: 'M21_01_P009',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 4,
    timeLimit: 420,
    question: {
      text: '一個籃子裡有15個蘋果，其中3個是壞的。隨機選取一個蘋果，求選到好蘋果的概率。',
      mathExpression: '求 P(好蘋果) = ?'
    },
    solution: {
      steps: [
        '總蘋果數 = 15個',
        '壞蘋果數 = 3個',
        '好蘋果數 = 15 - 3 = 12個',
        'P(好蘋果) = 12/15 = 4/5'
      ],
      finalAnswer: '4/5',
      explanation: '好蘋果數 = 總數 - 壞蘋果數'
    },
    hint: '先算出好蘋果的數量',
    tags: ['基本概率', '實際應用', '對立事件']
  },
  {
    id: 'M21_01_P010',
    topicId: 'M21_01',
    type: 'calculation',
    difficulty: 'advanced',
    points: 5,
    timeLimit: 600,
    question: {
      text: '從1到20的數字中隨機選擇一個，求選到的數字既是3的倍數又是偶數的概率。',
      mathExpression: '求 P(3的倍數且偶數) = ?'
    },
    solution: {
      steps: [
        '1到20的數字：{1, 2, 3, ..., 20}',
        '3的倍數且偶數 = 6的倍數',
        '6的倍數：{6, 12, 18}',
        '符合條件的數字數 = 3個',
        'P(3的倍數且偶數) = 3/20'
      ],
      finalAnswer: '3/20',
      explanation: '同時是3的倍數和偶數的數就是6的倍數'
    },
    hint: '同時是3的倍數和偶數的數字有什麼特點？',
    tags: ['基本概率', '倍數', '交集']
  }
];

// ========== 2. 條件概率 (Conditional Probability) ==========
export const M21_02_PROBLEMS = [
  {
    id: 'M21_02_P001',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一個盒子裡有4個紅球和6個藍球。先抽出一個紅球不放回，然後再抽第二個球。求第二個球也是紅球的概率。',
      mathExpression: '求 P(第二個是紅球|第一個是紅球) = ?'
    },
    solution: {
      steps: [
        '第一次抽出紅球後，剩餘情況：',
        '紅球：4 - 1 = 3個',
        '藍球：6個',
        '總球數：10 - 1 = 9個',
        'P(第二個是紅球|第一個是紅球) = 3/9 = 1/3'
      ],
      finalAnswer: '1/3',
      explanation: '條件概率：在已知第一個是紅球的條件下，計算第二個也是紅球的概率'
    },
    hint: '第一個紅球被抽走後，剩下多少個紅球和總球數？',
    tags: ['條件概率', '不放回', '依賴事件']
  },
  {
    id: 'M21_02_P002',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一副撲克牌中，已知抽到的牌是黑色的，求這張牌是黑桃的概率。',
      mathExpression: '求 P(黑桃|黑色) = ?'
    },
    solution: {
      steps: [
        '黑色牌包括：黑桃和梅花',
        '黑色牌總數 = 13 + 13 = 26張',
        '黑桃數 = 13張',
        'P(黑桃|黑色) = 13/26 = 1/2'
      ],
      finalAnswer: '1/2',
      explanation: '在黑色牌中，黑桃和梅花各佔一半'
    },
    hint: '黑色牌包括哪兩種花色？',
    tags: ['條件概率', '撲克牌', '花色']
  },
  {
    id: 'M21_02_P003',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '投擲兩枚骰子，已知兩個點數的和是偶數，求和為8的概率。',
      mathExpression: '求 P(和為8|和為偶數) = ?'
    },
    solution: {
      steps: [
        '和為偶數的情況：兩個都是奇數或兩個都是偶數',
        '和為偶數的組合：18個',
        '和為8的組合：(2,6), (3,5), (4,4), (5,3), (6,2)',
        '和為8且為偶數：5個',
        'P(和為8|和為偶數) = 5/18'
      ],
      finalAnswer: '5/18',
      explanation: '在和為偶數的條件下，計算和為8的相對概率'
    },
    hint: '先找出所有和為偶數的情況，再找其中和為8的情況',
    tags: ['條件概率', '骰子', '和數']
  },
  {
    id: 'M21_02_P004',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一個班級中，60%的學生喜歡數學，40%的學生喜歡物理，25%的學生兩科都喜歡。已知一個學生喜歡數學，求他也喜歡物理的概率。',
      mathExpression: '求 P(喜歡物理|喜歡數學) = ?'
    },
    solution: {
      steps: [
        '設A = 喜歡數學，B = 喜歡物理',
        'P(A) = 0.6，P(B) = 0.4，P(A∩B) = 0.25',
        'P(B|A) = P(A∩B) / P(A)',
        'P(B|A) = 0.25 / 0.6 = 25/60 = 5/12'
      ],
      finalAnswer: '5/12',
      explanation: '條件概率公式：P(B|A) = P(A∩B) / P(A)'
    },
    hint: '使用條件概率公式：P(B|A) = P(A∩B) / P(A)',
    tags: ['條件概率', '百分比', '條件概率公式']
  },
  {
    id: 'M21_02_P005',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '有兩個盒子：盒子A有3個白球和2個黑球，盒子B有1個白球和4個黑球。隨機選擇一個盒子，然後從中抽球。已知抽到白球，求是從盒子A抽的概率。',
      mathExpression: '求 P(盒子A|白球) = ?'
    },
    solution: {
      steps: [
        'P(選盒子A) = P(選盒子B) = 1/2',
        'P(白球|盒子A) = 3/5，P(白球|盒子B) = 1/5',
        'P(白球) = 1/2 × 3/5 + 1/2 × 1/5 = 3/10 + 1/10 = 4/10 = 2/5',
        'P(盒子A|白球) = P(白球|盒子A) × P(盒子A) / P(白球)',
        'P(盒子A|白球) = (3/5 × 1/2) / (2/5) = (3/10) / (2/5) = 3/4'
      ],
      finalAnswer: '3/4',
      explanation: '使用貝葉斯定理計算反向條件概率'
    },
    hint: '這是貝葉斯定理問題，需要先計算P(白球)的總概率',
    tags: ['條件概率', '貝葉斯定理', '全概率公式']
  },
  {
    id: 'M21_02_P006',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '抽牌遊戲中，第一張牌是A，第二張牌是K（不放回）。求第三張牌是Q的概率。',
      mathExpression: '求 P(第三張是Q|前兩張是A和K) = ?'
    },
    solution: {
      steps: [
        '前兩張牌抽走了A和K',
        '剩餘牌數：52 - 2 = 50張',
        '剩餘Q的數量：4張（四種花色的Q都還在）',
        'P(第三張是Q|前兩張是A和K) = 4/50 = 2/25'
      ],
      finalAnswer: '2/25',
      explanation: '在已知前兩張牌的條件下，剩餘牌堆中Q的比例'
    },
    hint: '抽走兩張牌後，還剩多少張牌？Q還有幾張？',
    tags: ['條件概率', '撲克牌', '不放回']
  },
  {
    id: 'M21_02_P007',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '某種疾病的患病率是1%。檢測的準確率：患病者有95%會被檢出陽性，健康者有90%會被檢出陰性。一個人檢測結果為陽性，求他真的患病的概率。',
      mathExpression: '求 P(患病|檢測陽性) = ?'
    },
    solution: {
      steps: [
        'P(患病) = 0.01，P(健康) = 0.99',
        'P(陽性|患病) = 0.95，P(陰性|健康) = 0.90',
        'P(陽性|健康) = 1 - 0.90 = 0.10',
        'P(陽性) = 0.95 × 0.01 + 0.10 × 0.99 = 0.0095 + 0.099 = 0.1085',
        'P(患病|陽性) = (0.95 × 0.01) / 0.1085 ≈ 0.0876'
      ],
      finalAnswer: '約8.76%',
      explanation: '這是典型的醫學檢測貝葉斯問題，假陽性率很高'
    },
    hint: '使用貝葉斯定理，注意假陽性的影響',
    tags: ['條件概率', '貝葉斯定理', '醫學應用']
  },
  {
    id: 'M21_02_P008',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一個袋子裡有5個紅球和3個藍球。連續抽取兩個球（不放回）。已知第一個球是紅球，求第二個球是藍球的概率。',
      mathExpression: '求 P(第二個是藍球|第一個是紅球) = ?'
    },
    solution: {
      steps: [
        '第一個球是紅球後的情況：',
        '紅球剩餘：5 - 1 = 4個',
        '藍球剩餘：3個',
        '總球數剩餘：8 - 1 = 7個',
        'P(第二個是藍球|第一個是紅球) = 3/7'
      ],
      finalAnswer: '3/7',
      explanation: '在第一個球是紅球的條件下，第二個球從剩餘的7個球中選擇'
    },
    hint: '第一個紅球抽走後，剩餘球的組成如何？',
    tags: ['條件概率', '不放回', '序列抽取']
  },
  {
    id: 'M21_02_P009',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '投擲一枚硬幣3次，已知至少出現一次正面，求恰好出現兩次正面的概率。',
      mathExpression: '求 P(恰好兩次正面|至少一次正面) = ?'
    },
    solution: {
      steps: [
        '所有可能結果：{HHH, HHT, HTH, HTT, THH, THT, TTH, TTT}',
        '至少一次正面：除了TTT，共7種情況',
        '恰好兩次正面：{HHT, HTH, THH}，共3種情況',
        'P(恰好兩次正面|至少一次正面) = 3/7'
      ],
      finalAnswer: '3/7',
      explanation: '在至少一次正面的條件下，恰好兩次正面的相對概率'
    },
    hint: '先列出至少一次正面的所有情況，再找其中恰好兩次正面的情況',
    tags: ['條件概率', '硬幣', '多次投擲']
  },
  {
    id: 'M21_02_P010',
    topicId: 'M21_02',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '兩個學生獨立地解同一道題，學生A解對的概率是0.8，學生B解對的概率是0.7。已知至少有一個學生解對了，求學生A解對的概率。',
      mathExpression: '求 P(A解對|至少一個解對) = ?'
    },
    solution: {
      steps: [
        'P(A解對) = 0.8，P(B解對) = 0.7',
        'P(都解錯) = 0.2 × 0.3 = 0.06',
        'P(至少一個解對) = 1 - 0.06 = 0.94',
        'P(A解對且至少一個解對) = P(A解對) = 0.8',
        'P(A解對|至少一個解對) = 0.8 / 0.94 = 40/47'
      ],
      finalAnswer: '40/47',
      explanation: 'A解對包含在至少一個解對的事件中'
    },
    hint: '如果A解對了，那麼"至少一個解對"的條件自動滿足',
    tags: ['條件概率', '獨立事件', '至少問題']
  }
];

// ========== 3. 重複試驗 (Repeated Trials) ==========
export const M21_03_PROBLEMS = [
  {
    id: 'M21_03_P001',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '投擲一枚公平硬幣5次，求恰好出現3次正面的概率。',
      mathExpression: '求 P(5次中恰好3次正面) = ?'
    },
    solution: {
      steps: [
        '這是二項分布問題：n = 5, k = 3, p = 1/2',
        'P(X = k) = C(n,k) × p^k × (1-p)^(n-k)',
        'C(5,3) = 5!/(3!×2!) = 10',
        'P(恰好3次正面) = 10 × (1/2)^3 × (1/2)^2',
        'P(恰好3次正面) = 10 × (1/2)^5 = 10/32 = 5/16'
      ],
      finalAnswer: '5/16',
      explanation: '使用二項分布公式計算重複獨立試驗的概率'
    },
    hint: '使用二項分布公式，注意組合數的計算',
    tags: ['重複試驗', '二項分布', '硬幣']
  },
  {
    id: 'M21_03_P002',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '某射手射擊命中率為60%。射擊4次，求恰好命中2次的概率。',
      mathExpression: '求 P(4次中恰好命中2次) = ?'
    },
    solution: {
      steps: [
        '二項分布：n = 4, k = 2, p = 0.6',
        'C(4,2) = 4!/(2!×2!) = 6',
        'P(恰好2次命中) = 6 × (0.6)^2 × (0.4)^2',
        'P(恰好2次命中) = 6 × 0.36 × 0.16',
        'P(恰好2次命中) = 6 × 0.0576 = 0.3456'
      ],
      finalAnswer: '0.3456',
      explanation: '每次射擊是獨立的，使用二項分布計算'
    },
    hint: '識別這是二項分布問題，確定n, k, p的值',
    tags: ['重複試驗', '二項分布', '射擊']
  },
  {
    id: 'M21_03_P003',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '投擲一個六面骰子6次，求至少出現一次6點的概率。',
      mathExpression: '求 P(6次中至少一次6點) = ?'
    },
    solution: {
      steps: [
        '使用對立事件：P(至少一次6點) = 1 - P(沒有6點)',
        '每次投擲不是6點的概率 = 5/6',
        'P(6次都不是6點) = (5/6)^6',
        'P(6次都不是6點) = 15625/46656',
        'P(至少一次6點) = 1 - 15625/46656 = 31031/46656'
      ],
      finalAnswer: '31031/46656 ≈ 0.665',
      explanation: '對於"至少"問題，使用對立事件計算更簡單'
    },
    hint: '使用對立事件：至少一次 = 1 - 沒有一次',
    tags: ['重複試驗', '對立事件', '骰子', '至少問題']
  },
  {
    id: 'M21_03_P004',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '某學生考試及格率為80%。連續考試3次，求全部及格的概率。',
      mathExpression: '求 P(3次全部及格) = ?'
    },
    solution: {
      steps: [
        '每次考試及格的概率 = 0.8',
        '各次考試相互獨立',
        'P(3次全部及格) = P(第1次及格) × P(第2次及格) × P(第3次及格)',
        'P(3次全部及格) = 0.8 × 0.8 × 0.8 = (0.8)^3',
        'P(3次全部及格) = 0.512'
      ],
      finalAnswer: '0.512',
      explanation: '獨立事件的概率等於各個事件概率的乘積'
    },
    hint: '各次考試相互獨立，使用乘法原理',
    tags: ['重複試驗', '獨立事件', '考試']
  },
  {
    id: 'M21_03_P005',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '投擲兩枚硬幣，重複投擲3次。求恰好有2次出現一正一反的概率。',
      mathExpression: '求 P(3次中恰好2次一正一反) = ?'
    },
    solution: {
      steps: [
        '一次投擲兩枚硬幣，一正一反的概率：',
        'P(一正一反) = P(HT) + P(TH) = 1/4 + 1/4 = 1/2',
        '重複3次，恰好2次一正一反：',
        'n = 3, k = 2, p = 1/2',
        'P(恰好2次) = C(3,2) × (1/2)^2 × (1/2)^1 = 3 × 1/8 = 3/8'
      ],
      finalAnswer: '3/8',
      explanation: '先計算一次試驗的成功概率，再用二項分布'
    },
    hint: '先算出一次投擲兩枚硬幣一正一反的概率',
    tags: ['重複試驗', '複合事件', '硬幣']
  },
  {
    id: 'M21_03_P006',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '某工廠生產的產品次品率為5%。從生產線上連續取5個產品檢查，求最多有1個次品的概率。',
      mathExpression: '求 P(5個中最多1個次品) = ?'
    },
    solution: {
      steps: [
        '最多1個次品 = 0個次品 + 1個次品',
        'n = 5, p = 0.05',
        'P(0個次品) = C(5,0) × (0.05)^0 × (0.95)^5 = 1 × 1 × (0.95)^5',
        'P(1個次品) = C(5,1) × (0.05)^1 × (0.95)^4 = 5 × 0.05 × (0.95)^4',
        'P(最多1個次品) = (0.95)^5 + 5 × 0.05 × (0.95)^4 ≈ 0.774 + 0.204 = 0.978'
      ],
      finalAnswer: '0.978',
      explanation: '"最多"意味著要考慮所有不超過指定數量的情況'
    },
    hint: '最多1個 = 0個 + 1個，分別計算再相加',
    tags: ['重複試驗', '品質控制', '最多問題']
  },
  {
    id: 'M21_03_P007',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '抽籤活動中，每次抽中獎的概率是10%。抽取4次（每次抽完放回），求恰好中獎1次的概率。',
      mathExpression: '求 P(4次中恰好中獎1次) = ?'
    },
    solution: {
      steps: [
        '二項分布：n = 4, k = 1, p = 0.1',
        'C(4,1) = 4',
        'P(恰好中獎1次) = 4 × (0.1)^1 × (0.9)^3',
        'P(恰好中獎1次) = 4 × 0.1 × 0.729',
        'P(恰好中獎1次) = 0.2916'
      ],
      finalAnswer: '0.2916',
      explanation: '有放回的抽取，每次概率相同且獨立'
    },
    hint: '注意是有放回的，每次中獎概率都是10%',
    tags: ['重複試驗', '抽籤', '有放回']
  },
  {
    id: 'M21_03_P008',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '某學生答選擇題的正確率為75%。連續答5題，求至少答對4題的概率。',
      mathExpression: '求 P(5題中至少答對4題) = ?'
    },
    solution: {
      steps: [
        '至少答對4題 = 答對4題 + 答對5題',
        'n = 5, p = 0.75',
        'P(答對4題) = C(5,4) × (0.75)^4 × (0.25)^1 = 5 × 0.316 × 0.25 = 0.395',
        'P(答對5題) = C(5,5) × (0.75)^5 × (0.25)^0 = 1 × 0.237 × 1 = 0.237',
        'P(至少答對4題) = 0.395 + 0.237 = 0.632'
      ],
      finalAnswer: '0.632',
      explanation: '"至少4題"包括恰好4題和全部5題正確'
    },
    hint: '至少4題 = 恰好4題 + 恰好5題',
    tags: ['重複試驗', '選擇題', '至少問題']
  },
  {
    id: 'M21_03_P009',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '投擲一枚不公平的硬幣，正面朝上的概率是2/3。投擲4次，求恰好2次正面朝上的概率。',
      mathExpression: '求 P(4次中恰好2次正面) = ?'
    },
    solution: {
      steps: [
        '二項分布：n = 4, k = 2, p = 2/3',
        'C(4,2) = 6',
        'P(恰好2次正面) = 6 × (2/3)^2 × (1/3)^2',
        'P(恰好2次正面) = 6 × 4/9 × 1/9',
        'P(恰好2次正面) = 6 × 4/81 = 24/81 = 8/27'
      ],
      finalAnswer: '8/27',
      explanation: '即使硬幣不公平，仍可使用二項分布，但要用正確的概率值'
    },
    hint: '注意硬幣不公平，正面概率是2/3而不是1/2',
    tags: ['重複試驗', '不公平硬幣', '分數計算']
  },
  {
    id: 'M21_03_P010',
    topicId: 'M21_03',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '某網站的每日訪問量服從泊松分布，平均每小時3次訪問。求在1小時內恰好有5次訪問的概率。（e^(-3) ≈ 0.0498）',
      mathExpression: '求 P(1小時內恰好5次訪問) = ?'
    },
    solution: {
      steps: [
        '泊松分布：P(X = k) = (λ^k × e^(-λ)) / k!',
        'λ = 3（平均每小時3次），k = 5',
        'P(X = 5) = (3^5 × e^(-3)) / 5!',
        'P(X = 5) = (243 × 0.0498) / 120',
        'P(X = 5) = 12.1014 / 120 ≈ 0.101'
      ],
      finalAnswer: '0.101',
      explanation: '泊松分布適用於稀有事件在固定時間內的發生次數'
    },
    hint: '這是泊松分布問題，使用泊松分布公式',
    tags: ['重複試驗', '泊松分布', '網站訪問']
  }
];

// ========== 4. 組合概率 (Combinatorial Probability) ==========
export const M21_04_PROBLEMS = [
  {
    id: 'M21_04_P001',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '從10名學生中選擇3名組成委員會，其中5名男生，5名女生。求委員會中恰好有2名男生的概率。',
      mathExpression: '求 P(委員會中恰好2名男生) = ?'
    },
    solution: {
      steps: [
        '總的選擇方法：C(10,3) = 120',
        '恰好2男1女的方法：C(5,2) × C(5,1)',
        'C(5,2) = 10，C(5,1) = 5',
        '有利情況數 = 10 × 5 = 50',
        'P(恰好2名男生) = 50/120 = 5/12'
      ],
      finalAnswer: '5/12',
      explanation: '使用組合數計算有利情況與總情況的比例'
    },
    hint: '用組合數分別計算選男生和女生的方法，然後相乘',
    tags: ['組合概率', '委員會', '性別分組']
  },
  {
    id: 'M21_04_P002',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一個盒子裡有6個紅球和4個藍球。同時抽取3個球，求恰好抽到2個紅球的概率。',
      mathExpression: '求 P(3個球中恰好2個紅球) = ?'
    },
    solution: {
      steps: [
        '總球數 = 10，同時抽3個',
        '總的抽取方法：C(10,3) = 120',
        '恰好2紅1藍的方法：C(6,2) × C(4,1)',
        'C(6,2) = 15，C(4,1) = 4',
        '有利情況數 = 15 × 4 = 60',
        'P(恰好2個紅球) = 60/120 = 1/2'
      ],
      finalAnswer: '1/2',
      explanation: '超幾何分布：從有限總體中無放回抽樣'
    },
    hint: '這是超幾何分布問題，用組合數計算',
    tags: ['組合概率', '超幾何分布', '同時抽取']
  },
  {
    id: 'M21_04_P003',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '一副撲克牌（52張）中抽取5張牌，求恰好抽到一對（兩張相同點數的牌）的概率。',
      mathExpression: '求 P(恰好一對) = ?'
    },
    solution: {
      steps: [
        '總的抽法：C(52,5)',
        '一對的選法：',
        '1. 選擇對子的點數：13種選擇',
        '2. 從4張同點數牌中選2張：C(4,2) = 6',
        '3. 選另外3張不同點數：從剩餘12個點數中選3個：C(12,3)',
        '4. 每個點數選1張：4^3',
        '一對的總數 = 13 × 6 × C(12,3) × 4^3',
        'P(恰好一對) = [13 × 6 × 220 × 64] / C(52,5)'
      ],
      finalAnswer: '約42.3%',
      explanation: '撲克牌組合概率需要仔細考慮各種約束條件'
    },
    hint: '分步驟考慮：選對子點數、選對子牌、選其他牌',
    tags: ['組合概率', '撲克牌', '複雜組合']
  },
  {
    id: 'M21_04_P004',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '12個人圍圓桌而坐，其中有4對夫妻和4個單身者。求4對夫妻都坐在一起的概率。',
      mathExpression: '求 P(4對夫妻都相鄰) = ?'
    },
    solution: {
      steps: [
        '總的圓形排列：(12-1)! = 11!',
        '有利情況：把每對夫妻看作一個整體',
        '8個單位（4對夫妻+4個單身）的圓形排列：(8-1)! = 7!',
        '每對夫妻內部可交換：2^4',
        '有利情況數 = 7! × 2^4',
        'P(都相鄰) = (7! × 2^4) / 11!'
      ],
      finalAnswer: '8/165',
      explanation: '圓桌排列問題，將夫妻看作整體處理'
    },
    hint: '將每對夫妻看作一個整體，然後考慮內部排列',
    tags: ['組合概率', '圓桌排列', '約束條件']
  },
  {
    id: 'M21_04_P005',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '從1到20的數字中隨機選擇5個不同的數字，求這5個數字中最大的是15的概率。',
      mathExpression: '求 P(5個數字中最大值是15) = ?'
    },
    solution: {
      steps: [
        '總的選法：C(20,5)',
        '最大值是15的條件：',
        '1. 必須選15',
        '2. 其餘4個從1到14中選：C(14,4)',
        '有利情況數 = C(14,4)',
        'P(最大值是15) = C(14,4) / C(20,5)',
        'P(最大值是15) = 1001 / 15504 = 13/201'
      ],
      finalAnswer: '13/201',
      explanation: '最大值為某特定值時，其餘數字必須都小於該值'
    },
    hint: '最大值是15意味著必須選15，其餘4個從更小的數中選',
    tags: ['組合概率', '最值問題', '數字選擇']
  },
  {
    id: 'M21_04_P006',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '一個班級有30名學生，隨機分成6個小組，每組5人。求某兩個特定學生分在同一組的概率。',
      mathExpression: '求 P(兩個特定學生同組) = ?'
    },
    solution: {
      steps: [
        '方法一：考慮第一個學生已分組',
        '第一個學生分到某組後，該組還需4人',
        '剩餘29人中，第二個學生被分到同組的概率',
        'P(同組) = 4/29',
        '',
        '方法二：直接計算',
        'P(同組) = 1/6 × 4/29 × 6 = 4/29'
      ],
      finalAnswer: '4/29',
      explanation: '可以用條件概率的思想簡化計算'
    },
    hint: '考慮第一個學生已分組的情況下，第二個學生的選擇',
    tags: ['組合概率', '分組問題', '條件思維']
  },
  {
    id: 'M21_04_P007',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '有5個不同的球放入3個不同的盒子，每個盒子至少放一個球。求第一個盒子恰好放2個球的概率。',
      mathExpression: '求 P(第一個盒子恰好2球|每盒至少1球) = ?'
    },
    solution: {
      steps: [
        '每盒至少1球的總方法數：S(5,3) × 3! = 25 × 6 = 150',
        '第一盒恰好2球的方法：',
        '1. 從5球中選2球放第一盒：C(5,2) = 10',
        '2. 剩餘3球分給2、3盒且都非空：2^3 - 2 = 6',
        '有利情況數 = 10 × 6 = 60',
        'P(第一盒恰好2球) = 60/150 = 2/5'
      ],
      finalAnswer: '2/5',
      explanation: '這是有約束條件的分配問題，需要用斯特林數'
    },
    hint: '先計算滿足條件的總情況，再計算第一盒恰好2球的情況',
    tags: ['組合概率', '分配問題', '約束條件']
  },
  {
    id: 'M21_04_P008',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '從26個英文字母中隨機選擇4個字母組成無意義的4字母"單詞"（可重複），求4個字母都不相同的概率。',
      mathExpression: '求 P(4個字母都不同) = ?'
    },
    solution: {
      steps: [
        '總的4字母組合：26^4（每位都有26種選擇）',
        '4個字母都不同的組合：26 × 25 × 24 × 23',
        '（第一個26種，第二個25種，依此類推）',
        'P(都不同) = (26 × 25 × 24 × 23) / 26^4',
        'P(都不同) = (25 × 24 × 23) / 26^3 = 13800/17576'
      ],
      finalAnswer: '13800/17576 ≈ 0.785',
      explanation: '這是有放回vs無放回的概率比較'
    },
    hint: '分子是無放回抽取，分母是有放回抽取',
    tags: ['組合概率', '字母組合', '重複與不重複']
  },
  {
    id: 'M21_04_P009',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '某數學競賽有10道選擇題，每題4個選項。一個學生完全猜測答案，求恰好答對6題的概率。',
      mathExpression: '求 P(10題中恰好答對6題) = ?'
    },
    solution: {
      steps: [
        '每題答對概率 p = 1/4，答錯概率 = 3/4',
        '二項分布：n = 10, k = 6, p = 1/4',
        'P(恰好6題) = C(10,6) × (1/4)^6 × (3/4)^4',
        'C(10,6) = 210',
        'P(恰好6題) = 210 × (1/4)^6 × (3/4)^4',
        'P(恰好6題) = 210 × (1/4096) × (81/256) ≈ 0.0162'
      ],
      finalAnswer: '約0.0162',
      explanation: '完全猜測的選擇題服從二項分布'
    },
    hint: '每題猜對概率是1/4，使用二項分布公式',
    tags: ['組合概率', '選擇題', '猜測']
  },
  {
    id: 'M21_04_P010',
    topicId: 'M21_04',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '8個人排成一排，其中有3個人是好朋友，必須站在一起。求滿足條件的排列概率。',
      mathExpression: '求 P(3個好朋友相鄰) = ?'
    },
    solution: {
      steps: [
        '總排列數：8!',
        '3個好朋友相鄰的排列：',
        '1. 把3個好朋友看作一個整體',
        '2. 6個單位（1個整體+5個人）的排列：6!',
        '3. 3個好朋友內部排列：3!',
        '有利情況數 = 6! × 3!',
        'P(相鄰) = (6! × 3!) / 8! = (720 × 6) / 40320 = 3/28'
      ],
      finalAnswer: '3/28',
      explanation: '將需要相鄰的人看作一個整體來處理'
    },
    hint: '將3個好朋友看作一個整體，然後考慮內部排列',
    tags: ['組合概率', '排列', '相鄰約束']
  }
];

// ========== 5. 幾何概率 (Geometric Probability) ==========
export const M21_05_PROBLEMS = [
  {
    id: 'M21_05_P001',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在邊長為4的正方形內隨機取一點，求該點到正方形中心距離小於2的概率。',
      mathExpression: '求 P(到中心距離 < 2) = ?'
    },
    solution: {
      steps: [
        '正方形面積 = 4 × 4 = 16',
        '到中心距離小於2的區域是半徑為2的圓',
        '圓的面積 = π × 2² = 4π',
        '由於圓完全在正方形內（2 < 4/2）',
        'P(距離 < 2) = 4π / 16 = π/4'
      ],
      finalAnswer: 'π/4',
      explanation: '幾何概率 = 有利區域面積 / 總區域面積'
    },
    hint: '計算滿足條件的區域面積（圓形）與總區域面積（正方形）的比值',
    tags: ['幾何概率', '正方形', '圓形', '距離']
  },
  {
    id: 'M21_05_P002',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'basic',
    points: 4,
    timeLimit: 360,
    question: {
      text: '在長度為10的線段上隨機取一點，求該點距離左端點的距離大於3且小於7的概率。',
      mathExpression: '求 P(3 < 距離 < 7) = ?'
    },
    solution: {
      steps: [
        '線段總長度 = 10',
        '滿足條件的區間：(3, 7)',
        '滿足條件的長度 = 7 - 3 = 4',
        'P(3 < 距離 < 7) = 4/10 = 2/5'
      ],
      finalAnswer: '2/5',
      explanation: '一維幾何概率：有利長度 / 總長度'
    },
    hint: '找出滿足條件的線段長度',
    tags: ['幾何概率', '線段', '一維', '區間']
  },
  {
    id: 'M21_05_P003',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '兩人約定在某地會面，約定時間是下午2點到4點。每人在這2小時內隨機到達，且等待30分鐘。求兩人能夠見面的概率。',
      mathExpression: '求 P(兩人見面) = ?'
    },
    solution: {
      steps: [
        '設兩人到達時間分別為x和y（以分鐘為單位，0≤x,y≤120）',
        '總區域：正方形[0,120]×[0,120]，面積 = 120²',
        '見面條件：|x-y| ≤ 30',
        '滿足條件的區域：-30 ≤ x-y ≤ 30',
        '不滿足條件的區域：兩個三角形',
        '每個三角形面積 = (1/2) × 90 × 90 = 4050',
        '滿足條件區域面積 = 120² - 2×4050 = 14400 - 8100 = 6300',
        'P(見面) = 6300/14400 = 7/16'
      ],
      finalAnswer: '7/16',
      explanation: '這是經典的會面問題，需要在二維平面上分析'
    },
    hint: '將問題轉化為二維平面上的幾何區域問題',
    tags: ['幾何概率', '會面問題', '二維', '絕對值不等式']
  },
  {
    id: 'M21_05_P004',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在半徑為6的圓內隨機取一點，求該點位於內接正三角形內部的概率。',
      mathExpression: '求 P(點在內接正三角形內) = ?'
    },
    solution: {
      steps: [
        '圓的面積 = π × 6² = 36π',
        '內接正三角形的邊長 = 6√3（圓半徑為6）',
        '正三角形面積 = (√3/4) × (6√3)² = (√3/4) × 108 = 27√3',
        'P(在三角形內) = 27√3 / 36π = 3√3 / 4π'
      ],
      finalAnswer: '3√3/(4π)',
      explanation: '需要計算圓的內接正三角形面積'
    },
    hint: '先求出內接正三角形的邊長，再計算面積',
    tags: ['幾何概率', '圓形', '內接三角形', '面積計算']
  },
  {
    id: 'M21_05_P005',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '在單位正方形[0,1]×[0,1]內隨機選擇兩點，求這兩點之間距離小於0.5的概率。',
      mathExpression: '求 P(兩點距離 < 0.5) = ?'
    },
    solution: {
      steps: [
        '這是4維問題：兩點(x₁,y₁)和(x₂,y₂)',
        '總的樣本空間：[0,1]⁴，體積 = 1',
        '距離條件：(x₁-x₂)² + (y₁-y₂)² < 0.25',
        '這個積分較複雜，可用蒙特卡羅方法或',
        '幾何分析得到近似值',
        '通過數值計算：P ≈ 0.306'
      ],
      finalAnswer: '約0.306',
      explanation: '這是高維幾何概率問題，通常需要數值方法求解'
    },
    hint: '這是4維空間的幾何概率問題，可以考慮數值方法',
    tags: ['幾何概率', '高維', '距離', '複雜積分']
  },
  {
    id: 'M21_05_P006',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在邊長為a的等邊三角形內隨機取一點，求該點到三邊距離之和等於該三角形高的概率。',
      mathExpression: '求 P(到三邊距離和 = 高) = ?'
    },
    solution: {
      steps: [
        '等邊三角形的一個重要性質：',
        '內部任意一點到三邊距離之和等於三角形的高',
        '因此，每個內部點都滿足這個條件',
        'P(距離和 = 高) = 1'
      ],
      finalAnswer: '1',
      explanation: '這是等邊三角形的一個著名性質：維瓦尼定理'
    },
    hint: '這涉及等邊三角形的一個特殊性質',
    tags: ['幾何概率', '等邊三角形', '維瓦尼定理', '特殊性質']
  },
  {
    id: 'M21_05_P007',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在矩形[0,4]×[0,3]內隨機取一點，求該點到矩形四個頂點距離之和的最小值對應的概率。',
      mathExpression: '求該點為矩形中心的概率'
    },
    solution: {
      steps: [
        '矩形中心點為(2, 1.5)',
        '由於是連續分佈，任何特定點的概率為0',
        '但如果考慮該點的鄰域，或者',
        '如果題目問的是離散情況下的近似',
        'P(恰好是中心點) = 0'
      ],
      finalAnswer: '0',
      explanation: '連續分佈中單點事件的概率為0'
    },
    hint: '在連續分佈中，單個點的概率是多少？',
    tags: ['幾何概率', '矩形', '連續分佈', '單點事件']
  },
  {
    id: 'M21_05_P008',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '向邊長為2的正方形內隨機投擲一個半徑為0.2的硬幣，求硬幣完全落在正方形內的概率。',
      mathExpression: '求 P(硬幣完全在正方形內) = ?'
    },
    solution: {
      steps: [
        '硬幣中心必須距離正方形邊界至少0.2的距離',
        '有效區域是邊長為2-2×0.2=1.6的正方形',
        '有效區域面積 = 1.6² = 2.56',
        '總區域面積 = 2² = 4',
        'P(完全落在內部) = 2.56/4 = 0.64'
      ],
      finalAnswer: '0.64',
      explanation: '硬幣中心的有效投擲區域縮小了'
    },
    hint: '考慮硬幣中心能夠投擲的有效區域',
    tags: ['幾何概率', '投擲問題', '有效區域', '邊界效應']
  },
  {
    id: 'M21_05_P009',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'intermediate',
    points: 5,
    timeLimit: 480,
    question: {
      text: '在區間[0,2π]上隨機選擇一個角度θ，求sin(θ) > 1/2的概率。',
      mathExpression: '求 P(sin θ > 1/2) = ?'
    },
    solution: {
      steps: [
        'sin θ > 1/2 的解：π/6 < θ < 5π/6',
        '滿足條件的區間長度 = 5π/6 - π/6 = 4π/6 = 2π/3',
        '總區間長度 = 2π',
        'P(sin θ > 1/2) = (2π/3) / 2π = 1/3'
      ],
      finalAnswer: '1/3',
      explanation: '需要解三角不等式找出滿足條件的角度範圍'
    },
    hint: '解不等式sin θ > 1/2，找出角度範圍',
    tags: ['幾何概率', '三角函數', '不等式', '角度']
  },
  {
    id: 'M21_05_P010',
    topicId: 'M21_05',
    type: 'calculation',
    difficulty: 'advanced',
    points: 6,
    timeLimit: 600,
    question: {
      text: '在單位圓x²+y²≤1內隨機取一點，求該點的極坐標中極角θ滿足0≤θ≤π/3的概率。',
      mathExpression: '求 P(0 ≤ θ ≤ π/3) = ?'
    },
    solution: {
      steps: [
        '單位圓的總面積 = π',
        '0 ≤ θ ≤ π/3 對應的扇形',
        '扇形的圓心角 = π/3',
        '扇形面積 = (π/3)/(2π) × π = π/6',
        'P(0 ≤ θ ≤ π/3) = (π/6)/π = 1/6'
      ],
      finalAnswer: '1/6',
      explanation: '扇形面積與圓面積的比值'
    },
    hint: '計算對應扇形的面積',
    tags: ['幾何概率', '極坐標', '扇形', '圓形']
  }
];

// 導出所有問題數據
export const M21_ALL_PROBLEMS = [
  ...M21_01_PROBLEMS,
  ...M21_02_PROBLEMS,
  ...M21_03_PROBLEMS,
  ...M21_04_PROBLEMS,
  ...M21_05_PROBLEMS
];

// 統計信息
export const M21_PROBLEMS_STATS = {
  totalProblems: M21_ALL_PROBLEMS.length,
  byTopic: {
    'M21_01': M21_01_PROBLEMS.length,
    'M21_02': M21_02_PROBLEMS.length,
    'M21_03': M21_03_PROBLEMS.length,
    'M21_04': M21_04_PROBLEMS.length,
    'M21_05': M21_05_PROBLEMS.length
  },
  byDifficulty: {
    basic: M21_ALL_PROBLEMS.filter(p => p.difficulty === 'basic').length,
    intermediate: M21_ALL_PROBLEMS.filter(p => p.difficulty === 'intermediate').length,
    advanced: M21_ALL_PROBLEMS.filter(p => p.difficulty === 'advanced').length
  },
  totalPoints: M21_ALL_PROBLEMS.reduce((sum, p) => sum + p.points, 0),
  averageTimeLimit: M21_ALL_PROBLEMS.reduce((sum, p) => sum + p.timeLimit, 0) / M21_ALL_PROBLEMS.length
}; 